// extracted by mini-css-extract-plugin
export default {"head":"styles_head__f9k6a","headCell":"styles_headCell__P9rp-"};